import { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { RenovationFormKey } from '../MessageForms.types';

import { RenovationDIYForm } from './RenovationDIYForm';
import { RenovationPaintingKitForm } from './RenovationPaintingKitForm';

export const renovationForms: Record<
  RenovationFormKey,
  FC<ParsedEntry<IWidget>>
> = {
  [RenovationFormKey.RENOVATION_PAINTING]: RenovationPaintingKitForm,
  [RenovationFormKey.RENOVATION_DIY]: RenovationDIYForm,
};
